import React, { useContext, useState, useEffect } from 'react';
import { HomeProductContext } from './homeProductContext';
import { Link } from 'gatsby';
import LocalizedLink from './localizedLink';
import useTranslations from '../utils/useTranslations';
import NavPopup from './navPopup';
import NavItem2 from './NavItem2';
import btLogo from '../images/bt-logo-black.svg';
import utLogo from '../images/ut-logo-green.svg';
import baiLogo from '../images/bai-logo.svg';
import { FaWindows } from 'react-icons/fa';
import { FaApple } from 'react-icons/fa';
import { FaAndroid } from 'react-icons/fa';
import { CompatibilityContext } from '../components/compatibilityContext';
import { unlocalizedPageCheck } from '../utils/unlocalizedPageCheck';
import {
    Collapse,
    Container,
    Navbar,
    NavbarToggler,
    Nav,
    NavItem,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Dropdown,
} from 'reactstrap';
import { NavContext } from './NavContext';
import HelpCenterLinks from './help-center/helpCenterLinks';

const navSelections = ['Products', 'Language'];

const isBt = process.env.BRAND === 'bt';
const remoteLink = isBt ? 'https://remote.bittorrent.com' : 'https://remote.utorrent.com/';
const neoProductLink = '/products/mac/neo/';
const neoDownloadLink = '/downloads/complete/neo/';

const Navigation = (props) => {
    const homeProduct = useContext(HomeProductContext);
    const { unlocalizedPath, navText } = props.pageContext;
    const t = useTranslations(navText);
    const isBt = process.env.BRAND === 'bt';

    const [isOpen, setIsOpen] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [selected, setSelected] = useState(null);
    const [showMobileMenuList, setShowMobileMenuList] = useState([false, false]);
    const [isMobile, setIsMobile] = useState<boolean | undefined>(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        setIsMobile(window.gatsbyIsMobile);
    }, []);

    const closeModal = (e) => {
        e.preventDefault();
        setIsModalOpen(false);
    };

    const toggle = () => {
        setIsOpen((open) => !open);
    };

    const togglePopup = (selected) => {
        if (selected !== null) {
            window.document.body.setAttribute('style', 'overflow:hidden');
            setIsPopupOpen(true);
            setSelected(selected);
        } else {
            window.document.body.setAttribute('style', 'overflow:scroll');
            setIsPopupOpen(false);
            setSelected(selected);
        }
    };

    const toggleMobile = (selected) => {
        let index = navSelections.indexOf(selected);
        let mobileMenuList = showMobileMenuList;
        mobileMenuList = mobileMenuList.map((item, i) => {
            return index === i ? !item : false;
        });
        setShowMobileMenuList(mobileMenuList);
    };

    //ref to control nav from page level
    const toggleNav = (selected) => {
        if (isMobile) {
            setIsOpen(true);
            toggleMobile(selected);
        } else {
            togglePopup(selected);
        }
    };

    const [prevToggleNavPage, setPrevToggleNavPage] = useState(props.toggleNavPage);
    if (prevToggleNavPage !== props.toggleNavPage) {
        setPrevToggleNavPage(props.toggleNavPage);
        toggleNav(props.toggleNavPage);
    }

    return (
        <>
            {isOpen && <div className="nav-mobile-bg-container" onClick={toggle}></div>}
            <Navbar
                container={false}
                light
                expand="md"
                style={{
                    backgroundColor: `#ffffff`,
                    boxShadow: '0px 53px 300px -25px rgba(0,0,0,0.75)',
                }}
            >
                <Container fluid>
                    <LocalizedLink
                        to="/"
                        id="mainnav-bt-logo"
                        onClick={event => {
                            togglePopup(null);
                            if (!event.defaultPrevented && event.button === 0
                                && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
                                homeProduct?.resetProduct();
                            }
                        }}
                    >
                        <div className="navbar-brand mb-0 tw-items-cente tw-flex tw-py-2">
                            {isBt ? (
                                <img
                                    className="tw-h-[30px]"
                                    src={btLogo}
                                    alt="BitTorrent - The Original Torrent Client"
                                />
                            ) : (
                                <img className="tw-h-[40px]" src={utLogo} alt="µTorrent - The Better Torrent Client" />
                            )}
                        </div>
                    </LocalizedLink>

                    <div className="tw-ml-auto tw-flex tw-items-center tw-gap-2 md:tw-hidden">
                        <a
                            id="nav-button"
                            href="https://chat.b.ai/chat?utm_source=bt"
                            className="tw-flex tw-h-[32px] tw-items-center tw-justify-center tw-gap-2 tw-rounded-[8px]
                                tw-bg-[#FFFDF7] tw-pe-[8px] tw-ps-[12px] tw-text-[14px] tw-text-black
                                tw-shadow-[0_0_12px_0_#DECFA8B3]"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {t('Try AI')}
                            <img src={baiLogo} className="tw-h-[13px] tw-w-[10px]" alt="Try AI" />
                        </a>
                        <NavbarToggler onClick={toggle} />
                    </div>

                    <Collapse isOpen={isOpen} navbar>
                        <Nav className="ml-auto d-flex d-md-none nav-mobile" navbar>
                            <Dropdown
                                nav
                                inNavbar
                                isOpen={showMobileMenuList[0]}
                                toggle={() => {}}
                                onClick={() => {
                                    toggleMobile(navSelections[0]);
                                }}
                            >
                                <DropdownToggle nav caret>
                                    {t(`Products`)}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <LocalizedLink
                                        to="/products/"
                                        id="mainnav-products-viewall-mobile"
                                        className="nav-mobile-link dropdown-item"
                                        onClick={toggle}
                                    >
                                        {t(`View All`)}
                                    </LocalizedLink>
                                    <DropdownItem divider />
                                    <h6 className="dropdown-header">{t(`Torrent Downloaders`)}</h6>
                                    <DropdownItem divider />
                                    <div className="position-relative">
                                        <FaWindows className="position-absolute nav-mobile-icon" />
                                        <LocalizedLink
                                            to="/products/win/web-free/"
                                            id="mainnav-products-btweb-windows-mobile"
                                            className="nav-mobile-link dropdown-item"
                                            onClick={toggle}
                                        >
                                            {isBt ? 'BitTorrent' : 'µTorrent'} Web
                                        </LocalizedLink>
                                    </div>
                                    <div className="position-relative">
                                        <FaApple className="position-absolute nav-mobile-icon" />
                                        <LocalizedLink
                                            to="/products/mac/web-free/"
                                            id="mainnav-products-btweb-mac-mobile"
                                            className="nav-mobile-link dropdown-item"
                                            onClick={toggle}
                                        >
                                            {isBt ? 'BitTorrent' : 'µTorrent'} Web
                                        </LocalizedLink>
                                    </div>
                                    <div className="position-relative">
                                        <FaWindows className="position-absolute nav-mobile-icon" />
                                        <LocalizedLink
                                            to="/products/win/classic-free/"
                                            id="mainnav-products-btclassic-windows-mobile"
                                            className="nav-mobile-link dropdown-item"
                                            onClick={toggle}
                                        >
                                            {isBt ? 'BitTorrent' : 'µTorrent'} Classic
                                        </LocalizedLink>
                                    </div>
                                    <div className="position-relative">
                                        <FaAndroid className="position-absolute nav-mobile-icon" />
                                        <LocalizedLink
                                            to="/products/android/android-free/"
                                            id="mainnav-products-android-mobile"
                                            className="nav-mobile-link dropdown-item"
                                            onClick={toggle}
                                        >
                                            {isBt ? 'BitTorrent' : 'µTorrent'} Android
                                        </LocalizedLink>
                                    </div>
                                    {isBt && (
                                        <div className="position-relative" data-download-path={neoDownloadLink}>
                                            <FaApple className="position-absolute nav-mobile-icon" />
                                            <LocalizedLink
                                                to={neoProductLink}
                                                id="mainnav-products-neo-mobile"
                                                className="nav-mobile-link dropdown-item"
                                                onClick={toggle}
                                            >
                                                BitTorrent Neo
                                                <span
                                                    className="tw-ml-2 tw-inline-flex tw-h-[18px] tw-items-center
                                                        tw-rounded-[3px] tw-bg-brand tw-px-1 tw-text-[10px]
                                                        tw-font-normal tw-leading-none tw-text-white"
                                                >
                                                    {t('NEW')}
                                                </span>
                                            </LocalizedLink>
                                        </div>
                                    )}

                                    <DropdownItem divider />
                                    <h6 className="dropdown-header">{t(`Content Utility`)}</h6>
                                    <DropdownItem divider />
                                    <a
                                        href={remoteLink}
                                        id="mainnav-products-btremote-mobile"
                                        className="nav-mobile-link dropdown-item"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        onClick={toggle}
                                    >
                                        {isBt ? 'BitTorrent' : 'µTorrent'} Remote
                                    </a>

                                    {isBt && (
                                        <>
                                            <DropdownItem divider />
                                            <h6 className="dropdown-header">{t(`Decentralized Inference`)}</h6>
                                            <DropdownItem divider />
                                            <a
                                                href="https://bttinfergrid.ai/"
                                                id="mainnav-token-btfs-mobile"
                                                className="nav-mobile-link dropdown-item"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                onClick={toggle}
                                            >
                                                BTTInferGrid
                                            </a>
                                        </>
                                    )}
                                </DropdownMenu>
                            </Dropdown>

                            <NavItem>
                                {isBt ? (
                                    <LocalizedLink
                                        to={HelpCenterLinks.homeLink}
                                        id="mainnav-help-mobile"
                                        className="nav-link text-decoration-none"
                                        onClick={toggle}
                                    >
                                        {t('Help')}
                                    </LocalizedLink>
                                ) : (
                                    <a
                                        href="https://forum.utorrent.com/"
                                        id="mainnav-help-mobile"
                                        className="nav-link text-decoration-none"
                                        rel="noopener noreferrer"
                                        onClick={toggle}
                                    >
                                        {t('Forum')}
                                    </a>
                                )}
                            </NavItem>

                            <Dropdown
                                nav
                                inNavbar
                                isOpen={showMobileMenuList[1]}
                                toggle={() => {}}
                                onClick={() => {
                                    toggleMobile(navSelections[1]);
                                }}
                            >
                                <DropdownToggle nav caret>
                                    {t(`Language`)}
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <div className="nav-mobile-languages">
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={unlocalizedPath}
                                                hrefLang="en"
                                                id="mainnav-lang-en-mobile"
                                                className="dropdown-item"
                                            >
                                                English
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/zh-cn' + unlocalizedPath
                                                }
                                                hrefLang="zh-cn"
                                                id="mainnav-lang-zh-cn-mobile"
                                                className="dropdown-item"
                                            >
                                                中文（简体）
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/zh-tw' + unlocalizedPath
                                                }
                                                hrefLang="zh-tw"
                                                id="mainnav-lang-zh-tw-mobile"
                                                className="dropdown-item"
                                            >
                                                中文（繁體）
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/de' + unlocalizedPath
                                                }
                                                hrefLang="de"
                                                id="mainnav-lang-de-mobile"
                                                className="dropdown-item"
                                            >
                                                Deutsch
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/es' + unlocalizedPath
                                                }
                                                hrefLang="es"
                                                id="mainnav-lang-es-mobile"
                                                className="dropdown-item"
                                            >
                                                Español
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/fr' + unlocalizedPath
                                                }
                                                hrefLang="fr"
                                                id="mainnav-lang-fr-mobile"
                                                className="dropdown-item"
                                            >
                                                Français
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/hi' + unlocalizedPath
                                                }
                                                hrefLang="hi"
                                                id="mainnav-lang-hi-mobile"
                                                className="dropdown-item"
                                            >
                                                हिन्दी
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/it' + unlocalizedPath
                                                }
                                                hrefLang="it"
                                                id="mainnav-lang-it-mobile"
                                                className="dropdown-item"
                                            >
                                                Italiano
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/ja' + unlocalizedPath
                                                }
                                                hrefLang="ja"
                                                id="mainnav-lang-ja-mobile"
                                                className="dropdown-item"
                                            >
                                                日本語
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/ko' + unlocalizedPath
                                                }
                                                hrefLang="ko"
                                                id="mainnav-lang-ko-mobile"
                                                className="dropdown-item"
                                            >
                                                한국어
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/nl' + unlocalizedPath
                                                }
                                                hrefLang="nl"
                                                id="mainnav-lang-nl-mobile"
                                                className="dropdown-item"
                                            >
                                                Nederlands
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/pl' + unlocalizedPath
                                                }
                                                hrefLang="pl"
                                                id="mainnav-lang-pl-mobile"
                                                className="dropdown-item"
                                            >
                                                Polski
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/pt-br' + unlocalizedPath
                                                }
                                                hrefLang="pt-br"
                                                id="mainnav-lang-pt-br-mobile"
                                                className="dropdown-item"
                                            >
                                                Português (Brasil)
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/pt' + unlocalizedPath
                                                }
                                                hrefLang="pt"
                                                id="mainnav-lang-pt-mobile"
                                                className="dropdown-item"
                                            >
                                                Português
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/ru' + unlocalizedPath
                                                }
                                                hrefLang="ru"
                                                id="mainnav-lang-ru-mobile"
                                                className="dropdown-item"
                                            >
                                                Русский
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/tl' + unlocalizedPath
                                                }
                                                hrefLang="tl"
                                                id="mainnav-lang-tl-mobile"
                                                className="dropdown-item"
                                            >
                                                Tagalog
                                            </Link>
                                        </DropdownItem>
                                        <DropdownItem onClick={toggle}>
                                            <Link
                                                to={
                                                    unlocalizedPageCheck(unlocalizedPath)
                                                        ? unlocalizedPath
                                                        : '/tr' + unlocalizedPath
                                                }
                                                hrefLang="tr"
                                                id="mainnav-lang-tr-mobile"
                                                className="dropdown-item"
                                            >
                                                Türkçe
                                            </Link>
                                        </DropdownItem>
                                    </div>
                                </DropdownMenu>
                            </Dropdown>
                        </Nav>
                    </Collapse>

                    <NavContext.Provider value={{ isPopupOpen: isPopupOpen, selected: selected }}>
                        <div className="tw-hidden tw-gap-5 md:tw-flex">
                            <a
                                href="https://chat.b.ai/chat?utm_source=bt"
                                id="nav-button"
                                className="tw-flex tw-h-[32px] tw-items-center tw-justify-center tw-gap-2
                                    tw-rounded-[8px] tw-bg-[#FFFDF7] tw-pe-[8px] tw-ps-[12px] tw-text-black
                                    tw-shadow-[0_0_12px_0_#DECFA8B3]"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {t('Try AI')}
                                <img src={baiLogo} className="tw-h-[13px] tw-w-[10px]" alt="Try AI" />
                            </a>
                            <NavItem2
                                caret
                                togglePopup={togglePopup}
                                intName={t('Products')}
                                name={navSelections[0]}
                                id="mainnav-products"
                            />
                            {isBt ? (
                                <LocalizedLink
                                    to={HelpCenterLinks.homeLink}
                                    id="mainnav-forum"
                                    className="tw-inline-flex tw-items-center tw-uppercase tw-text-black tw-outline-0
                                        tw-transition-colors tw-duration-300"
                                >
                                    {t('Help')}
                                </LocalizedLink>
                            ) : (
                                <NavItem2
                                    name={t('Forum')}
                                    href="https://forum.utorrent.com/"
                                    target="_blank"
                                    id="mainnav-forum"
                                />
                            )}
                            <NavItem2
                                caret
                                togglePopup={togglePopup}
                                intName={t(`Language`)}
                                name={navSelections[1]}
                                id="mainnav-language"
                            />
                        </div>
                        <CompatibilityContext.Consumer>
                            {(compatibilityContext) => (
                                <div
                                    style={{
                                        visibility: isPopupOpen ? 'visible' : 'hidden',
                                    }}
                                >
                                    <NavPopup
                                        togglePopup={togglePopup}
                                        isMobile={isMobile}
                                        unlocalizedPath={unlocalizedPath}
                                        navText={navText}
                                        compatibilityContext={compatibilityContext}
                                        isModalOpen={isModalOpen}
                                        close={closeModal}
                                    />
                                </div>
                            )}
                        </CompatibilityContext.Consumer>
                    </NavContext.Provider>
                </Container>
            </Navbar>
        </>
    );
};

export { NavContext };

export default Navigation;
